<template>
  <fragment>
    <slot />
    <hr v-if="!noDivider" v-bem:divider />
  </fragment>
</template>

<script>
export default {
  name: 'SummaryGroup',
  props: {
    noDivider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.summary-group {
  @at-root #{&}__divider {
    margin: utils.f-rem-calc(32) 0;
  }
}
</style>
